// src/store/slices/userSlice.ts
import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { UserData, User, Reservation } from "../../utils/Interface";

const initialState: UserData = {
  jwt: null,
  user: null,
  reservations: [],
  isUsedOnBorne: false, // Ajoutez cette ligne
  currentResId: ''
};

export const userSlice = createSlice({
  name: "auth",
  initialState,
  reducers: {
    setAuthData: (
      state,
      action: PayloadAction<{
        jwt: string;
        user: User;
        reservations: Reservation[];
        currentResId: string;
      }>
    ) => {
      state.jwt = action.payload.jwt;
      state.user = action.payload.user;
      state.reservations = action.payload.reservations;
      state.currentResId = action.payload.currentResId;
    },
    setUser(state, action: PayloadAction<User>) {
      state.user = action.payload;
    },
    setCurrentResId(state, action: PayloadAction<string>) {
      state.currentResId = action.payload;
    },
    setReservations(state, action: PayloadAction<Reservation[]>) {
      state.reservations = action.payload;
    },
    clearAuthData(state) {
      state.jwt = null;
      state.user = null;
      /*state.reservations = [];
      state.currentResId = null;*/
    },
    
    setIsUsedOnBorne(state, action: PayloadAction<boolean>) {
      // Ajoutez cette action
      state.isUsedOnBorne = action.payload;
    },
  },
});

export const {
  setAuthData,
  clearAuthData,
  setUser,
  setReservations,
  setIsUsedOnBorne,
  setCurrentResId
} = userSlice.actions;

export default userSlice.reducer;
